export default function Copyright() {
    const year = new Date().getFullYear();
    return <>© {year} CloudX Solutions Pvt Ltd. All rights reserved.</>;
};

